export const CHAT_SKELETON_ITEMS: number[] = Array(3).fill(0);

export const CHAT_SKELETON_ITEMS_INITIAL: number[] = Array(8).fill(0);

export const CHAT_SKELETON_IMAGE_THEME = {
	width: '48px',
	height: '48px',
	'border-radius': '8px',
	'margin-bottom': '0'
} as const;

export const CHAT_SKELETON_LINE_THEME = {
	height: '14px',
	'border-radius': '8px',
	width: '80%',
	'margin-bottom': '4px',
	'margin-top': '0'
} as const;

export const CHAT_SKELETON_LINE_SHORT_THEME = {
	height: '12px',
	'border-radius': '8px',
	width: '60%',
	'margin-bottom': '0',
	'margin-top': '0'
} as const;

export const CHAT_SKELETON_DATE_THEME = {
	height: '12px',
	'border-radius': '8px',
	width: '48px',
	'margin-bottom': '0'
} as const;

